<template>
    <DsBadge
        v-bind="$attrs"
        :icon
        :text
        :tooltipText
        :variant
    />
</template>

<script setup lang="ts">
import DsBadge, { type DsBadgeProps } from '@ds/badge/DsBadge.vue';

defineProps<DsBadgeProps>();
</script>
